import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BoSpinnerService, BoToastrService } from 'src/@core/shared';
import { Observable } from 'rxjs';
import { PaginationResponse, ErrorResponse } from '../config/common';
import { API } from '../config/api';
import { CustomerInvoice, RequestCustomerInvoice } from './customer-invoice.DTO';
import { tap, catchError } from 'rxjs/operators';
import { requestQuery } from 'src/@shared/untils';
import * as _ from 'lodash';
import { SUCCESS } from '../../../@shared/constants';
import { InvoiceLegend } from 'src/@shared/constants/invoiceLegend';

@Injectable()
export class CustomerInvoiceService {

    constructor(
        private _http: HttpClient,
        private _spinner: BoSpinnerService,
        private _toastr: BoToastrService
    ) { }

    // LAY TAT CA 
    public GetAllCustomerInvoice(request: RequestCustomerInvoice, disableSpinner?: boolean) {
        _.keys(request).forEach(key => {
            if (request[key] == null || request[key] == undefined) {
                delete request[key];
            }
        });
        if (!disableSpinner) {
            this._spinner.show(true);
        }
        return this._http.post(`${API.CUSTOMER_INVOICE.POST}`, request)
            .pipe(tap(() => this._spinner.hide()));
    }

    // THEM PROCESS INVOIEC
    public ProcessInvoice(model: string[]) {
        return this._http.post(`${API.CUSTOMER_INVOICE.PROCESS_INVOICE}`, model)
            .pipe(
                tap(() => {
                    this._spinner.hide();
                    this._toastr.successCode(SUCCESS.PROCESS_INVOICE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }
    public PreviewInvoice(invoiceIds: string[], printReportOnly: boolean = false) {
        const payload = {
            invoiceIds,
            printReportOnly
        };

        return this._http.post(`${API.CUSTOMER_INVOICE.PREVIEW_INVOICE}`, payload,  { responseType: "blob" });
    }

    // CHANGE INVOICE STATE
    public ChangeInvoiceState(model) {
        return this._http.post(`${API.CUSTOMER_INVOICE.CHANGE_INVOICE_STATE}`, model)
            .pipe(
                tap(() => {
                    this._spinner.hide();
                    this._toastr.successCode(SUCCESS.ACCEPT_INVOICE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
	}

	public ChangeInvoiceLegend(consignmentId: string, legend: InvoiceLegend) {
		return this._http.put(`${API.CUSTOMER_INVOICE.CHANGE_INVOICE_LEGEND(consignmentId, legend)}`, {})
            .pipe(
                tap(() => {
                    this._spinner.hide();
                    this._toastr.successCode(SUCCESS.ON_HOLD_INVOICE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
	}

	public ReverseInvoiceLegend(consignmentId: string) {
		return this._http.put(`${API.CUSTOMER_INVOICE.REVERSE_INVOICE_LEGEND(consignmentId)}`, {})
            .pipe(
                tap(() => {
                    this._spinner.hide();
                    this._toastr.successCode(SUCCESS.REVERSE_INVOICE_LEGEND);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
	}
}
